import React from "react";
export function NavBarLogo () {
    return <img style={{width: "101px", height: "44px"}} src="/img/logo/SwivlStudioWritten.png" alt="swivl" />
}